import urls from "../../api/urls.json";
import { authorizedHttpGet, authorizedHttpPost } from "../../api/httpCalls";
import { useState, useRef, useEffect } from "react";
import Loader from "../Loader";
import { FlexWrapper, ParentDiv } from '../../styles/WrapperStyles'
import styled, { css } from 'styled-components';
import place_holder from '../../assests/placeholder_image.png'
import PageModal from "../modals/PageModal";
import { CommonTextStyleSpan } from "../../styles/TextStyles";
import { getDate, getSafeMediaUrl } from "../../utils";
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import EmptyView from "../EmptyView";
import '../styles/Banned.css';
import BannedOptionsModal from "../modals/BannedOptionsModal";
import { BaseButton } from "../../styles/ButtonStyles";
import chrome_icon from '../../assests/chrome_icon.png';
import delete_image from '../../assests/delete_image.png';
import heart from '../../assests/heart.png';
import add_icon from '../../assests/add_icon.png';
import crop_icon from '../../assests/crop.png';
import CropImage from '../CropImage';
import { convertTimestampToFormattedDate } from '../../utils';
import ShareRefControl from '../ShareRefControl';


const InputParentDiv = styled.label`
    position: relative;
    display: inline-block;
    width: 150px;
    height: 150px;
    border-radius: 15px;
    margin-right: 20px;
    background: #d7d7d7;
    cursor: pointer;
`;

const InputImage = styled.input`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const ActionButton = styled.button`
  cursor: pointer;
  width: 50px;
  height: 66px;
  border-radius: 33px;
  box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
  border: solid 1px #d7d7d7;
  background-color: #ffffff;
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #002b37;
  font-family: 'Gilory-Bold';
  ${props =>
        props.green &&
        css`
      background-color: green;
      color: white;
    `}
    ${props =>
        props.red &&
        css`
      background-color: red;
      color: white;
    `}
    ${props =>
        props.black &&
        css`
      background-color: black;
      color: white;
    `}
`;

const BottomBarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    margin-top: 50px;
    margin-bottom: 50px;
`;

const NameWrapper = styled.div`
margin-top: 80px;
  ${props =>
        props.width &&
        css`
      width: ${props.width};
    `}
`;


const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;

const HeaderWrapper = styled(FlexWrapper)`
    // display: inline;
    margin-left: 250px;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const BannedImageParentDiv = styled.div`
    
`;

const DeleteImageParentDiv = styled.div`
`;

const ChromeImageParent = styled.img`
    width: 20px;
    height: 20px;
    border-radius: 35px;
    position: absolute;
    cursor: pointer;
    visibility: hidden;
    ${BannedImageParentDiv}:hover & {
        visibility: visible;
    }
    margin-left: 5px;
    margin-top: 5px;
`;

const DeleteImageParent = styled.img`
    width: 20px;
    height: 20px;
    border-radius: 35px;
    position: absolute;
    cursor: pointer;
    visibility: hidden;
    ${BannedImageParentDiv}:hover & {
        visibility: visible;
    }
    margin-left: 6px;
    margin-top: 125px;
`;

const CropImageIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-top: -35px;
  margin-left: 115px;
  background-color: #ffffff;
  border: solid 3px #ffffff;
  display: flex;
  border-radius: 35px;
  position: absolute;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  visibility: hidden;
  ${BannedImageParentDiv}:hover & {
    visibility: visible;
  }
`;

const HeartParent = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 8%;
  margin-top: -10.5%;
  background-color: #ffffff;
  border: solid 3px #9b9b9b;
  position: absolute;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  visibility: hidden;
  ${props =>
        props.selected &&
        css`
      border: solid 3px #53e03f;
    `}
  ${BannedImageParentDiv}:hover & {
    visibility: visible;
  }
`;

const InsideImageStyle = styled.img`
  width: 15px;
  height: 15px;
`;

const HeaderTextView = styled.span`
    font-family:'Gilory-Semi';
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `}
    ${props =>
        props.selected &&
        css`
        color: #767676;
        font-family: 'Gilory-Bold';
      `}
    ${props =>
        props.cursor &&
        css`
        cursor: pointer;
      `}
`;


const AutoCurateFeedNew = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const handleLeftNavAppChange = (name) => {
        setAppName(name)
    };
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const totalPages = useRef(1);
    const [displayPageModal, setDisplayPageModal] = useState(false);
    const [bannedImages, setBannedImages] = useState([]);
    const [dropDownOptions, setDropDownOptions] = useState([])
    const [banOption, setBanOption] = useState('All')
    const [displayBanOptionModal, setDisplayBanOptionModal] = useState(false)
    const [approvedProfiles, setApprovedProfiles] = useState([])
    const [rejectedProfiles, setRejectedProfiles] = useState([])
    const [inappropriateProfiles, setInappropriateProfiles] = useState([])
    const [showCropImage, setShowCropImage] = useState(false)
    const [cropPhoto, setCropPhoto] = useState('');
    const [decoyImages, setDecoyImages] = useState(false)
    const [profileStateTab, setProfileStateTab] = useState('Approve');
    const sharingSourceTabMapper = {
        Approve: "Autofeed-approved",
        Disapprove: "Autofeed-disapproved",
        Inapropriate: "Autofeed-inappropriate"
    };
    const dragOverItem = useRef();
    const dragImageUrl = useRef();
    const profileState = {
        'Approve': 'approved',
        'Disapprove': 'disapproved',
        'Inapropriate': 'inappropriated',
    }
    const profileStateToArrayMapper = {
        'Approve': setApprovedProfiles,
        'Disapprove': setRejectedProfiles,
        'Inapropriate': setInappropriateProfiles,
    }
    const [imagesEdited, setImagesEdited] = useState([])

    const openGoogleImages = (imageUrl) => {
        navigator.clipboard.writeText(imageUrl);
        window.open('https://www.google.com/imghp', '_blank');
    }

    const handleProfileStateTabChange = (name) => {
        setProfileStateTab(name);
        setPage(1);
    }

    const handlePageChange = (direction) => {
        if (direction === 'next') {
            if (page < totalPages.current) {
                setPage(parseInt(page) + 1);
            }
        } else {
            if (page > 1) {
                setPage(parseInt(page) - 1);
            }
        }

    }

    const goToPage = (pageNumber) => {
        if (pageNumber <= totalPages.current && pageNumber >= 1) {
            setPage(pageNumber);
        }
        setDisplayPageModal(false);
    }

    const closeModal = () => {
        setDisplayPageModal(false);
    }

    const fetchBannedInfo = async () => {
        setLoading(true);
        let params = { page: page, profile_state: profileState[profileStateTab], type: 'auto_curate' }
        let response = await authorizedHttpGet(urls.GET_FEED, params)
        if (response.status) {
            totalPages.current = response.data.total_pages;
            setBannedImages(response.data.profile_list);
            setApprovedProfiles([])
            setRejectedProfiles([])
            setInappropriateProfiles([])
        }
        setLoading(false);
    }

    const getBanOption = (option) => {
        setBanOption(option)
        setDisplayBanOptionModal(false)
    }

    useEffect(() => {
        fetchBannedInfo();
    }, [page, appName, banOption, profileStateTab]);

    const handleAction = (profile, action) => {
        if (action === 'approve') {
            if (checkIfRefExists(profile.ref, 'approve')) {
                let remove_profile = approvedProfiles.filter((item) => item.ref !== profile.ref)
                setApprovedProfiles(remove_profile)
                return;
            }
            setApprovedProfiles([...approvedProfiles, profile])
            let remove_profile = rejectedProfiles.filter((item) => item.ref !== profile.ref)
            setInappropriateProfiles(inappropriateProfiles.filter((item) => item.ref !== profile.ref))
            setRejectedProfiles(remove_profile)
        } else if (action === 'disapprove') {
            if (checkIfRefExists(profile.ref, 'disapp')) {
                let remove_profile = rejectedProfiles.filter((item) => item.ref !== profile.ref)
                setRejectedProfiles(remove_profile)
                return;
            }
            let remove_profile = approvedProfiles.filter((item) => item.ref !== profile.ref)
            setApprovedProfiles(remove_profile)
            setInappropriateProfiles(inappropriateProfiles.filter((item) => item.ref !== profile.ref))
            setRejectedProfiles([...rejectedProfiles, profile])
        } else {
            if (checkIfRefExists(profile.ref, 'inapp')) {
                let remove_profile = inappropriateProfiles.filter((item) => item.ref !== profile.ref)
                setInappropriateProfiles(remove_profile)
                return;
            }
            let remove_profile = approvedProfiles.filter((item) => item.ref !== profile.ref)
            setApprovedProfiles(remove_profile)
            remove_profile = rejectedProfiles.filter((item) => item.ref !== profile.ref)
            setRejectedProfiles(remove_profile)
            setInappropriateProfiles([...inappropriateProfiles, profile])
        }


    }

    const checkIfRefExists = (ref, type) => {
        let exists = false;
        if (type === 'approve') {
            approvedProfiles.forEach((item) => {
                if (item.ref === ref) {
                    exists = true;
                }
            })
        } else if (type === 'disapp') {
            rejectedProfiles.forEach((item) => {
                if (item.ref === ref) {
                    exists = true;
                }
            })
        } else {
            inappropriateProfiles.forEach((item) => {
                if (item.ref === ref) {
                    exists = true;
                }
            })
        }
        return exists;
    }

    const handleApprovedImages = () => {
        const refsNotTobeIncluded = [];
        rejectedProfiles.forEach((rejectedProfile) => refsNotTobeIncluded.push(rejectedProfile.ref))
        inappropriateProfiles.forEach((inappropriateProfile) => refsNotTobeIncluded.push(inappropriateProfile.ref))

        const newApprovedProfiles = bannedImages.filter((profile) => !refsNotTobeIncluded.includes(profile.ref))
        return [newApprovedProfiles, rejectedProfiles, inappropriateProfiles];
    }

    const handleDisapprovedImages = () => {
        const refsNotTobeIncluded = [];
        approvedProfiles.forEach((approvedProfile) => refsNotTobeIncluded.push(approvedProfile.ref))
        inappropriateProfiles.forEach((inappropriateProfile) => refsNotTobeIncluded.push(inappropriateProfile.ref))
        const newRejectedProfiles = bannedImages.filter((profile) => !refsNotTobeIncluded.includes(profile.ref))
        return [approvedProfiles, newRejectedProfiles, inappropriateProfiles];
    }

    const handleInappropriateImages = () => {
        const refsNotTobeIncluded = [];
        approvedProfiles.forEach((approvedProfile) => refsNotTobeIncluded.push(approvedProfile.ref))
        rejectedProfiles.forEach((rejectedProfile) => refsNotTobeIncluded.push(rejectedProfile.ref))
        const newInappropriateProfiles = bannedImages.filter((profile) => !refsNotTobeIncluded.includes(profile.ref))
        return [approvedProfiles, rejectedProfiles, newInappropriateProfiles]
    }

    const removeFromEditedImages = () => {

        const methodMapper = {
            'Approve': handleApprovedImages,
            'Disapprove': handleDisapprovedImages,
            'Inapropriate': handleInappropriateImages,
        }

        const [approvedProfiles, rejectedProfiles, inappropriateProfiles] = methodMapper[profileStateTab]();
    }

    const saveData = async () => {
        setLoading(true);
        const methodMapper = {
            'Approve': handleApprovedImages,
            'Disapprove': handleDisapprovedImages,
            'Inapropriate': handleInappropriateImages,
        }

        const [approvedProfiles, rejectedProfiles, inappropriateProfiles] = methodMapper[profileStateTab]();

        let response = await authorizedHttpPost(urls.APPROVE_DISAPPROVE, { "type": 'auto_curate', reviewPassed: [], "approve": approvedProfiles, "disapprove": rejectedProfiles, "inappropriate": inappropriateProfiles, "editedImages": imagesEdited });
        if (response.status) {
            setApprovedProfiles([])
            setRejectedProfiles([])
            setInappropriateProfiles([])
            setImagesEdited([])
            fetchBannedInfo();
        }
    }

    const deleteImages = (ref, photo_id) => {
        bannedImages.forEach((item) => {
            if (item.ref === ref) {
                if (item.photos.length === 1) {
                    return;
                }
                let new_photos = item.photos.filter((photo) => photo.photo_id !== photo_id)
                item.photos = new_photos;
                setDecoyImages(!decoyImages)
            }
        })
    }

    const addImage = (event, ref) => {
        const file = event.target.files[0];
        // props.addImage(URL.createObjectURL(file));
        const reader = new FileReader();

        reader.onload = (e) => {
            const base64String = e.target.result.split(',')[1];
            const imageData = `data:image/jpeg;base64,${base64String}`
            bannedImages.forEach((item) => {
                if (item.ref === ref) {
                    if (item.photos.length === 4) {
                        return;
                    }
                    let new_photos = item.photos;
                    new_photos.push({ "photo": imageData })
                    item.photos = new_photos;
                    setDecoyImages(!decoyImages)
                }
            })
        };

        reader.readAsDataURL(file);
    }

    const checkIfPhotoSelected = (photo_id, ref) => {
        let selected = false;
        bannedImages.forEach((item) => {
            if (item.ref === ref) {
                item.photos.forEach((photo) => {
                    if (photo.photo_id === photo_id) {
                        if (photo['selected']) {
                            selected = true;
                        }
                    }
                })
            }
        })
        return selected;
    }

    const selectImage = (photo_id, ref) => {
        bannedImages.forEach((item) => {
            if (item.ref === ref) {
                item.photos.forEach((photo) => {
                    if (photo.photo_id === photo_id) {
                        photo['selected'] = true
                    } else {
                        photo['selected'] = false
                    }
                })
            }
        })
        setDecoyImages(!decoyImages)
    }

    const dragStart = (e, position, url) => {
        dragImageUrl.current = url;
        dragOverItem.current = position;
    };

    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };

    const dropImage = (ref) => {
        setDecoyImages(!decoyImages);
        if (dragOverItem.current !== null) {
            bannedImages.forEach((item) => {
                if (item.ref === ref) {
                    item.photos[dragOverItem.current] = { "photo": dragImageUrl.current };
                }
            })
            dragImageUrl.current = null;
            dragOverItem.current = null;
        }
    }

    const showImageCrop = (photo, index, ref) => {
        setCropPhoto(photo)
        setShowCropImage(true);
        sessionStorage.setItem('cropRef', ref)
        sessionStorage.setItem('cropIndex', index)
    }

    const saveCroppedImage = (croppedImage) => {
        setDecoyImages(!decoyImages);
        bannedImages.forEach((item) => {
            if (item.ref === sessionStorage.getItem('cropRef')) {
                item.photos[sessionStorage.getItem('cropIndex')] = { "photo": croppedImage }
                setImagesEdited([...imagesEdited, item])
            }
        })
        setShowCropImage(false);
    }

    const getProfileDetails = (image) => {
        const gender = image.gender === 'Male' ? 'M' : 'F';
        const age = image.age || 'age NA';
        const maritalStatus = (image.marital_status_v1 && image.marital_status_v1['name']) || 'marital status NA';
        const language = image.language || 'language NA';
        const location = image.location_str;
        const applicationDate = convertTimestampToFormattedDate(image.application_date);
        const phoneCode = image.phone_code || 'phone code NA';
        const name = image.first_name || 'name NA';

        const detailsArray = [name, gender, age, maritalStatus, language, location, applicationDate, phoneCode];
        return detailsArray.join('/');
    }

    return (
        <div className="App">
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Feed Auto Curated'} />
            <div className="bannedMainDiv">
                {loading && <Loader />}
                {displayBanOptionModal && <BannedOptionsModal closeModal={() => setDisplayBanOptionModal(false)} reportOptions={dropDownOptions} getBanOption={getBanOption} />}
                {displayPageModal && <PageModal goToPage={goToPage} page={page} closeModal={closeModal} />}
                {showCropImage ? <CropImage photo={cropPhoto} closeModal={() => setShowCropImage(false)} saveCroppedImage={saveCroppedImage} /> : null}
                <FlexWrapper className="marginTop25">
                    <HeaderWrapper className="cursorPointer" onClick={() => setDisplayPageModal(true)}>
                        <HeaderSelected className="marginLeft10">{page}</HeaderSelected>
                        <HeaderSelected className="marginLeft10">{totalPages.current}</HeaderSelected>
                    </HeaderWrapper>
                    <HeaderWrapper onClick={() => setDisplayBanOptionModal(true)} className="marginLeft10">
                        <HeaderSelected>{banOption}</HeaderSelected>
                    </HeaderWrapper>
                </FlexWrapper>
                <ParentDiv>
                    <FlexWrapper>
                        <div className='headerWrapperDiv headerWrapperFeed'>
                            <HeaderTextView marginRight cursor selected={profileStateTab === 'Approve'} onClick={() => handleProfileStateTabChange('Approve')}>Approve</HeaderTextView>
                            <HeaderTextView marginRight cursor selected={profileStateTab === 'Disapprove'} onClick={() => handleProfileStateTabChange('Disapprove')}>Disapprove</HeaderTextView>
                            <HeaderTextView marginRight cursor selected={profileStateTab === 'Inapropriate'} onClick={() => handleProfileStateTabChange('Inapropriate')}>Inapropriate</HeaderTextView>
                        </div>
                    </FlexWrapper>
                </ParentDiv>
                <div className="bannedImages">
                    {
                        bannedImages.map((profile) => (
                            <>
                                <div className="autoCuratedProfilesBox">
                                    {
                                        profile.photos.map((image, index) => (
                                            <div
                                                key={index}
                                                onDragStart={(e) => dragStart(e, index, image.photo)}
                                                onDragEnter={(e) => dragEnter(e, index)}
                                                onDragEnd={() => dropImage(profile.ref)}>
                                                <div className="deletedText"></div>
                                                {
                                                    image.photo ?
                                                        <BannedImageParentDiv>
                                                            <DeleteImageParent onClick={() => deleteImages(profile.ref, image.photo_id)} src={delete_image} />
                                                            <ChromeImageParent onClick={() => openGoogleImages(image.photo)} alt="chrome" src={chrome_icon} />
                                                            <img alt={image.photo} src={getSafeMediaUrl(image.photo, place_holder)} onError={(e) => e.target.src = place_holder} className="bannedImageStyles" loading="lazy" />
                                                            <HeartParent selected={checkIfPhotoSelected(image.photo_id, profile.ref)} onClick={() => selectImage(image.photo_id, profile.ref)}>
                                                                {
                                                                    checkIfPhotoSelected(image.photo_id, profile.ref) ? <InsideImageStyle src={heart} /> : null
                                                                }
                                                            </HeartParent>
                                                            < CropImageIcon onClick={() => {
                                                                showImageCrop(image.photo, index, profile.ref)
                                                            }}>
                                                                <InsideImageStyle src={crop_icon} />
                                                            </CropImageIcon>
                                                        </BannedImageParentDiv> :
                                                        <InputParentDiv>
                                                            <Image src={add_icon} alt="Add" />
                                                            <InputImage id="fileInput" type="file" onChange={(e) => addImage(e, image.ref)} />
                                                        </InputParentDiv>
                                                }
                                            </div>
                                        ))
                                    } {
                                        profile.hive_deleted_images.length > 0 &&
                                        profile.hive_deleted_images.map((image, index) => (
                                            <div className="deletedImageDiv"
                                                key={index}
                                                onDragStart={(e) => dragStart(e, index, image)}
                                                onDragEnter={(e) => dragEnter(e, index)}
                                                onDragEnd={() => dropImage(profile.ref)}>
                                                <div className="deletedText">Deleted</div>
                                                {
                                                    <BannedImageParentDiv>
                                                        <DeleteImageParent onClick={() => deleteImages(profile.ref, image)} src={delete_image} />
                                                        <ChromeImageParent onClick={() => openGoogleImages(image)} alt="chrome" src={chrome_icon} />
                                                        <img alt={image} src={getSafeMediaUrl(image, place_holder)} onError={(e) => e.target.src = place_holder} className="bannedImageStyles" loading="lazy" />
                                                        < CropImageIcon onClick={() => {
                                                            showImageCrop(image, index, profile.ref)
                                                        }}>
                                                            <InsideImageStyle src={crop_icon} />
                                                        </CropImageIcon>
                                                    </BannedImageParentDiv>
                                                }
                                            </div>
                                        ))
                                    }
                                    {profile.selfie_url ? <div>
                                        <div style={{ visibility: 'hidden' }}>Deleted</div>
                                        <img alt={profile.selfie_url} src={getSafeMediaUrl(profile.selfie_url, place_holder)} onError={(e) => e.target.src = place_holder} className="bannedImageStyles" />
                                    </div> : null}
                                </div>
                                <NameWrapper>
                                    <CommonTextStyleSpan highlight>
                                        {getDate(profile.banned_time)}
                                    </CommonTextStyleSpan>
                                    <br />
                                    <CommonTextStyleSpan>
                                        {profile.curator} <br /> {profile.ref}{' '}
                                    </CommonTextStyleSpan>
                                    <ShareRefControl
                                        refValue={profile.ref}
                                        sourceTab={sharingSourceTabMapper[profileStateTab]}
                                        compact={true}
                                    />
                                </NameWrapper>
                                <div className="actionButtonBannedDiv">
                                    {profileStateTab !== 'Approve' && <ActionButton green={checkIfRefExists(profile.ref, 'approve')} onClick={() => handleAction(profile, 'approve')}>L</ActionButton>}
                                    {profileStateTab !== 'Disapprove' && <ActionButton red={checkIfRefExists(profile.ref, 'disapp')} onClick={() => handleAction(profile, 'disapprove')}>P</ActionButton>}
                                    {profileStateTab !== 'Inapropriate' && <ActionButton black={checkIfRefExists(profile.ref, 'inapp')} onClick={() => handleAction(profile, 'inappropriate')}>I</ActionButton>}
                                </div>
                                <p>{getProfileDetails(profile)}</p>
                            </>
                        ))
                    }
                </div>
                {
                    bannedImages.length > 0 &&
                    <BottomBarWrapper>
                        {page === 1 ? <img alt="previous_inctive" src={previous_inctive} className="cursorPointer" /> : <img alt="previous_active" src={previous_active} onClick={() => handlePageChange('previous')} className="cursorPointer" />}
                        {page === totalPages.current ? <img alt="next_inactive" className="nextInctiveStyle" src={next_inactive} onClick={() => handlePageChange('next')} /> : <img className="nextInctiveStyle" alt="next_active" src={next_active} onClick={() => handlePageChange('next')} />}
                    </BottomBarWrapper>
                }
                {
                    bannedImages.length > 0 &&
                    <BaseButton onClick={saveData} green>Save</BaseButton>
                }
                {
                    bannedImages.length === 0 && <EmptyView />
                }
            </div>
        </div>
    );
}

export default AutoCurateFeedNew;
